"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const PointPreloader_1 = __importDefault(require("../../Preloaders/PointPreloader"));
const MatchRecordingGroupsHeader_1 = __importDefault(require("@Components/MatchComponents/MatchRecordingGroups/MatchRecordingGroupsHeader"));
const MatchingRecordingGroupsTable_1 = __importDefault(require("@Components/MatchComponents/MatchRecordingGroups/MatchingRecordingGroupsTable"));
const contexts_1 = require("@App/contexts");
const MatchingHelperText_1 = __importDefault(require("@Components/MatchComponents/MatchRecordingGroups/MatchRecordingGroupsHeader/MatchingHelperText"));
const mobx_react_1 = require("mobx-react");
const MatchRecordingGroups = (props) => {
    var _a, _b, _c;
    const { loading, loadMore } = props;
    const { matchingStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const selectedCount = matchingStore.selectedUnmatchedRecordingGroups.length;
    const totalCount = ((_a = matchingStore.unmatchedSearchResults) === null || _a === void 0 ? void 0 : _a.count) || 0;
    const currentCount = ((_c = (_b = matchingStore.unmatchedSearchResults) === null || _b === void 0 ? void 0 : _b.recordingGroups) === null || _c === void 0 ? void 0 : _c.length) || 0;
    const hasResults = !!matchingStore.unmatchedSearchResults;
    return (react_1.default.createElement("div", { className: "unmatched-search-results" },
        react_1.default.createElement(MatchRecordingGroupsHeader_1.default, { totalCount: totalCount, currentCount: currentCount, selectedCount: selectedCount }),
        react_1.default.createElement("div", { className: "results-body" },
            react_1.default.createElement(react_1.default.Fragment, null, loading ? (react_1.default.createElement(PointPreloader_1.default, null)) : (react_1.default.createElement(react_1.default.Fragment, null, hasResults &&
                (totalCount > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(MatchingRecordingGroupsTable_1.default, null),
                    currentCount < totalCount && currentCount < 200 && (react_1.default.createElement("div", { className: "load-more-button", onClick: () => loadMore() },
                        react_1.default.createElement("p", null, "Load more results..."))))) : (react_1.default.createElement(MatchingHelperText_1.default, null)))))))));
};
exports.default = (0, mobx_react_1.observer)(MatchRecordingGroups);
